/**
 * SlatWall cross-section profile.
 *
 * Extracted from `_models/slatwall.stl` via `scripts/extract-profile.js`
 * (Ramer–Douglas–Peucker simplified at 0.01" tolerance). The raw STL is
 * the actual product geometry from the 3D artist.
 *
 * Stored in inches in the JSON; converted to feet here so the rest of
 * the visualizer's room math stays in feet.
 */

import type { CrossSectionProfile } from './profileRegistry';
import data from './slatwallProfilePoints.json';

const IN_TO_FT = 1 / 12;

const points = data.points.map(
  ([u, v]) => [u * IN_TO_FT, v * IN_TO_FT] as readonly [number, number],
);

export const SLATWALL_PROFILE: CrossSectionProfile = {
  id: 'SlatWall',
  points,
  depthSize: data.uSize * IN_TO_FT,
  verticalSize: data.vSize * IN_TO_FT,
};
